import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';

class PapC extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          <h4 className="par_header">Paper Categories</h4>
            <div className="par">
            <b><i>Please note that:</i></b> <br />
            The names/terms "FULL/REGULAR PAPERS" and "LATE BREAKING PAPERS" are used interchangeably; i.e., they are the same category. <br />
            The names/terms "SHORT PAPERS" and "POSITION PAPERS" are used interchangeably; i.e., they are the same category. <br />
            The names/terms "POSTER PAPERS" and "ABSTRACT/POSTER PAPERS" are used interchangeably; i.e., they are the same category.
            </div>
            <hr />
            <div className="par">
              <h6>- Full/Regular Research Papers (maximum of 7 pages; if the authors need extra pages, then the editors would permit one extra page as long as all 7+1 pages are fully utilized):</h6>
            
            <p className="pub_cps">PUBLICATION IN THE <a target="_blank" href="https://www.computer.org/conferences/cps">CPS</a> PROCEEDINGS:</p>
            Regular Research Papers should provide detail original research contributions. They must report new research results that represent a contribution to the field; sufficient details and support for the results and conclusions should also be provided. The work presented in regular papers are expected to be at a stage of maturity that with some additional work can be published as journal papers.
            <br/>
            <Link to="/csci2023/presentation_modes">Presentation Mode Options</Link>

            <br/><br/>
            <h6>- Short Papers (maximum of 5 pages; if the authors need extra pages, then the editors would permit one extra page as long as all 5+1 pages are fully utilized):</h6>
          
            <p className="pub_cps">PUBLICATION IN THE <a target="_blank" href="https://www.computer.org/conferences/cps">CPS</a> PROCEEDINGS:</p>

          Short papers report on ongoing research projects. They should provide overall research methodologies with some results. The work presented in short papers are expected to be at a stage of maturity that with some additional work can be published as regular papers.
          <br/>
          <Link to="/csci2023/presentation_modes">Presentation Mode Options</Link>

          <br/><br/>
          <h6>- Poster Papers (maximum of 3 pages; if the authors need extra pages, then the editors would permit one extra page as long as all 3+1 pages are fully utilized):</h6>
          
          <p className="pub_cps">PUBLICATION IN THE <a target="_blank" href="https://www.computer.org/conferences/cps">CPS</a> PROCEEDINGS:</p>

          Poster papers report on ongoing research projects that are still in their infancy (i.e., at very early stages). Such papers tend to provide research methodologies without yet concrete results.
          
          <br/> <br />
          <Link to="/csci2023/presentation_modes">Presentation Mode Options</Link>
            
            
            {/* <h6>- Full/Regular Research Papers (maximum of 6 pages):</h6>
              Regular Research Papers should provide detail original research
              contributions. They must report new research results that
              represent a contribution to the field; sufficient details and
              support for the results and conclusions should also be provided.
              The work presented in regular papers are expected to be at a
              stage of maturity that with some additional work can be
              published as journal papers. <br/>
              <Link to="/csci2023/paper_category_rrp">Read More</Link>
              <br/><br/>
            <h6>- Short Papers (maximum of 4 pages):</h6>
              Short papers report on ongoing research projects. They should
              provide overall research methodologies with some results. The
              work presented in short papers are expected to be at a stage of
              maturity that with some additional work can be published as
              regular papers. <br/>
              <Link to="/csci2023/paper_category_srp">Read More</Link>
              <br/><br/>
            <h6>- Poster Papers (maximum of 2 pages):</h6>
              Poster papers report on ongoing research projects that are
              still in their infancy (i.e., at very early stages). Such
              papers tend to provide research methodologies without yet
              concrete results.<br/>
              <Link to="/csci2023/paper_category_pst">Read More</Link> */}

            </div>
            
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default PapC;